import { all, call } from 'redux-saga/effects'
import {
    changePasswordReq, cityListReq, countryListReq, forgotPasswordReq,
    loginUserReq, operatorListReq, operatorRegisterReq, registerUserReq, stateListReq,
    customerLoginReq, operatorDetailReq, updateOperatorLocationReq,
    updateUserNotificationTokenReq, loginEmployeeReq, employeeChangePasswordReq,
    userListReq, renewTraiSubscriptionReq
} from './user/user.saga'

import {
    addBusinessReq, businessDetailReq, updateBusinessDetailReq,
    userBusinessListReq, businessCheckSubscriptionReq
} from './business/business.saga'
import { addBusinessLocationReq, businessLocationDetailReq, businessLocationListReq, updateBusinessLocationReq } from './business-location/businessLocation.saga'
import {
    addEmployeeAvailabilityReq, addEmployeeReq, employeeAttendanceListReq, employeeAvailabilityListReq,
    employeeClockInReq, employeeClockOutReq, employeeDashboardDataReq, employeeDetailReq,
    employeeListReq, employeeUpdateAvailabilityReq, employeeUpdateDetailsReq,
    removeEmployeeFromBusinessReq, employeeLoginCodeCheckReq, employeeAttendanceCheckReq
} from './employee/employee.saga'

import {
    addProjectReq, projectAssignEmployeeReq, projectDetailReq,
    projectListReq, projectRemoveEmployeeReq, updateProjectDetailReq, requestProjectReq,
    rejectProjectRequestReq
} from './project/project.saga'
import {
    addShiftReq, assignShiftReq, declineRequestShiftReq, requestShiftReq,
    shiftDetailReq, shiftListReq, shiftRemoveEmployeeReq, updateShiftReq
} from './shift/shift.saga'
import {
    addTaskReq, assignTaskReq, taskDetailReq, taskListReq, updateTaskDetailReq,
    updateTaskStatusReq, addTaskCommentReq
} from './task/task.saga'
import { chatListReq, chatSendMessageReq, messageListReq } from './chat/chat.saga'
import { createRequestReq, requestDetailReq, requestListReq, updateRequestStatusReq } from './request/request.saga'
import { addDocumentReq, documentDetailReq, documentListReq } from './document/document.saga'
import {
    addPolicyReq, assignPolicyReq, policyDetailReq, policyListReq,
    policyMarkCompleteReq
} from './policy/policy.saga'
import { contactUsMessageListReq, contactUsNewMessageReq } from './contact-us/contactUs.saga'
import {
    addSubscriptionReq, subscriptionListReq, updateSubscriptionReq, updateSubscriptionStatusReq,
    updateTransactionStatusReq, newTransactionReq
} from './subscription/subscription.saga'
import {
    addAssetReq, assetDetailReq, assetListReq, assignAssetReq,
    unAssignAssetReq, updateAssetStatusReq
} from './asset/asset.saga'
import {
    performanceAddGoalCommentReq, performanceGoalDetailsReq, performanceGoalListReq,
    performanceNewGoalReq, performanceNewRequestReq, performanceNewReviewReq, performanceRequestListReq,
    performanceReviewListReq, performanceUpdateGoalReq
} from './performance/peformance.saga'

import {
    auditAddLogCommentReq, auditAddLogReq, auditAssignUserReq,
    auditDetailReq, auditListReq, auditUpdateLogStatusReq, auditUpdateStatusReq,
    newAuditReq
} from './audit/audit.saga'

import {
    addVisitorRecordReq, visitorExitReq,
    visitorGetConfigurationReq, visitorListReq, visitorUpdateConfigurationReq
} from './visitor/visitor.saga'

import {
    newTaxRuleReq, provisionalPayslipReq, taxRuleListReq, updateTaxRuleReq,
    newPayslipReq, payslipReq, payslipDetailReq, updatePayslipPaymentReq
} from './payroll/payroll.saga'

import {
    addMerchantReq, merchantDetailReq, merchantListReq, updateMerchantDetailReq
} from './merchant/merchant.saga'

import {
    addSuppliesCategoryReq, addSuppliesItemReq, consumeSuppliesItemReq,
    suppliesCategoryListReq, suppliesItemDetailReq, suppliesItemListReq,
    updateSuppliesCategoryDetailReq, updateSuppliesItemStockReq
} from './supplies/supplies.saga'

export default function* rootSaga() {
    yield all([
        call(loginUserReq),
        call(customerLoginReq),
        call(registerUserReq),
        call(changePasswordReq),
        call(forgotPasswordReq),
        call(cityListReq),
        call(countryListReq),
        call(stateListReq),
        call(operatorListReq),
        call(operatorRegisterReq),
        call(operatorDetailReq),
        call(updateOperatorLocationReq),
        call(updateUserNotificationTokenReq),
        call(loginEmployeeReq),
        call(employeeChangePasswordReq),
        call(userListReq),
        call(renewTraiSubscriptionReq),
        call(addBusinessReq),
        call(businessDetailReq),
        call(updateBusinessDetailReq),
        call(userBusinessListReq),
        call(businessCheckSubscriptionReq),
        call(addBusinessLocationReq),
        call(businessLocationDetailReq),
        call(businessLocationListReq),
        call(updateBusinessLocationReq),
        call(addEmployeeAvailabilityReq),
        call(addEmployeeReq),
        call(employeeAttendanceListReq),
        call(employeeAvailabilityListReq),
        call(employeeClockInReq),
        call(employeeClockOutReq),
        call(employeeDashboardDataReq),
        call(employeeDetailReq),
        call(employeeListReq),
        call(employeeUpdateAvailabilityReq),
        call(employeeUpdateDetailsReq),
        call(removeEmployeeFromBusinessReq),
        call(employeeLoginCodeCheckReq),
        call(employeeAttendanceCheckReq),
        call(addProjectReq),
        call(projectAssignEmployeeReq),
        call(projectDetailReq),
        call(projectListReq),
        call(projectRemoveEmployeeReq),
        call(updateProjectDetailReq),
        call(requestProjectReq),
        call(rejectProjectRequestReq),
        call(addShiftReq),
        call(assignShiftReq),
        call(declineRequestShiftReq),
        call(requestShiftReq),
        call(shiftDetailReq),
        call(shiftListReq),
        call(shiftRemoveEmployeeReq),
        call(updateShiftReq),
        call(addTaskReq),
        call(assignTaskReq),
        call(taskDetailReq),
        call(taskListReq),
        call(updateTaskDetailReq),
        call(updateTaskStatusReq),
        call(addTaskCommentReq),
        call(chatListReq),
        call(chatSendMessageReq),
        call(messageListReq),
        call(createRequestReq),
        call(requestDetailReq),
        call(requestListReq),
        call(updateRequestStatusReq),
        call(addDocumentReq),
        call(documentDetailReq),
        call(documentListReq),
        call(addPolicyReq),
        call(assignPolicyReq),
        call(policyDetailReq),
        call(policyListReq),
        call(policyMarkCompleteReq),
        call(contactUsMessageListReq),
        call(contactUsNewMessageReq),
        call(addSubscriptionReq),
        call(subscriptionListReq),
        call(updateSubscriptionReq),
        call(updateSubscriptionStatusReq),
        call(updateTransactionStatusReq),
        call(newTransactionReq),
        call(addAssetReq),
        call(assetDetailReq),
        call(assetListReq),
        call(assignAssetReq),
        call(unAssignAssetReq),
        call(updateAssetStatusReq),
        call(performanceAddGoalCommentReq),
        call(performanceGoalDetailsReq),
        call(performanceGoalListReq),
        call(performanceNewGoalReq),
        call(performanceNewRequestReq),
        call(performanceNewReviewReq),
        call(performanceRequestListReq),
        call(performanceReviewListReq),
        call(performanceUpdateGoalReq),
        call(auditAddLogCommentReq),
        call(auditAddLogReq),
        call(auditAssignUserReq),
        call(auditDetailReq),
        call(auditListReq),
        call(auditUpdateLogStatusReq),
        call(auditUpdateStatusReq),
        call(newAuditReq),
        call(addVisitorRecordReq),
        call(visitorExitReq),
        call(visitorGetConfigurationReq),
        call(visitorListReq),
        call(visitorUpdateConfigurationReq),
        call(newTaxRuleReq),
        call(provisionalPayslipReq),
        call(taxRuleListReq),
        call(updateTaxRuleReq),
        call(newPayslipReq),
        call(payslipReq),
        call(payslipDetailReq),
        call(updatePayslipPaymentReq),
        call(addMerchantReq),
        call(merchantDetailReq),
        call(merchantListReq),
        call(updateMerchantDetailReq),
        call(addSuppliesCategoryReq),
        call(addSuppliesItemReq),
        call(consumeSuppliesItemReq),
        call(suppliesCategoryListReq),
        call(suppliesItemDetailReq),
        call(suppliesItemListReq),
        call(updateSuppliesCategoryDetailReq),
        call(updateSuppliesItemStockReq),
    ])
}